import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { useSpace } from '../../../hooks/useSpace';
import { keys as calendarKeys } from "../../calendar/api/keys";
import { keys as documentKeys } from "../../documents/api/keys";
import { deleteDriveFilesQuietly } from "../../documents/api/driveFiles";
import { meetingKeys } from './getMeetings';

async function deleteMeeting(id: string, spaceId: string) {
  // Read the report file urls first: deleting the meeting cascades the linked
  // document rows, but the underlying Drive files must be removed explicitly.
  const { data: documents } = await apiClient
    .from('documents')
    .select('file_url')
    .eq('meeting_id', id);

  const { error } = await apiClient
    .from('council_meetings')
    .delete()
    .eq('id', id)

  if (error) {
    throw error
  }

  await deleteDriveFilesQuietly((documents ?? []).map((doc) => doc.file_url), spaceId);
}

export function useDeleteMeeting() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: (id: string) => {
      if (!currentSpace) {
        throw new Error('Aucun espace sélectionné pour supprimer la réunion.');
      }

      return deleteMeeting(id, currentSpace.id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meetingKeys.lists() });
      queryClient.invalidateQueries({ queryKey: calendarKeys.list() });
      // The report also lived in documents (unified list).
      queryClient.invalidateQueries({ queryKey: documentKeys.documents });
    },
  });
}
